// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IDurationType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class DurationType implements IDurationType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Day DurationType
	**/
    get Day(): IDurationType {
        return this.FromId(1);
    }
    /**
		Returns Month DurationType
	**/
    get Month(): IDurationType {
        return this.FromId(2);
    }
    /**
		Returns Year DurationType
	**/
    get Year(): IDurationType {
        return this.FromId(3);
    }
    /**
		Returns Age DurationType
	**/
    get Age(): IDurationType {
        return this.FromId(4);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Day', displayValue: 'Day', description: 'Day', sortOrder: 999, active: true });
        this._dictionary.add('2', { id: 2, value: 'Month', displayValue: 'Month', description: 'Month', sortOrder: 999, active: true });
        this._dictionary.add('3', { id: 3, value: 'Year', displayValue: 'Year', description: 'Year', sortOrder: 999, active: true });
        this._dictionary.add('4', { id: 4, value: 'Age', displayValue: 'Age', description: 'Age', sortOrder: 999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IDurationType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IDurationType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IDurationType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IDurationType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): IDurationType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
